<div class="multiselect-box">
  <div class="control">
    <label (click)="showList = true"
      >{{ label }}
      <span class="required-indicator has-text-danger" *ngIf="required">*required</span>
    </label>
    <p class="help mb-1" *ngIf="helpText">{{ helpText }}</p>
    <div
      class="content help mb-1"
      [innerHTML]="htmlHelpText"
      *ngIf="htmlHelpText"
    ></div>

    <div class="columns">
      <div class="column" *ngFor="let group of optionGroups">
        <div class="group-title">
          <strong>{{ group.name }}</strong>
        </div>
        <div class="group-options">
          <div class="control my-4" *ngFor="let option of group.options">
            <label class="checkbox">
              <input
                type="checkbox"
                class="checkmark"
                [checked]="option.selected"
                (change)="toggleSelected(option)"
              />
              {{ option.label }}
            </label>
            <p
              *ngIf="option.description"
              class="help mt-1 ml-4"
              style="color: #6b6760; line-height: 1.6"
            >
              {{ option.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
